import { Injectable } from '@angular/core';

export interface ZikataToast {
  text: string;
  classname: string;
  delay: number;
  sticky?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ZikataToastService {
  toasts: ZikataToast[] = [];

  showSuccess(text: string)   { this.show(text, 'bg-success text-light'); }
  showError(text: string)     { this.show(text, 'bg-danger text-light'); }
  showWarning(text: string)   { this.show(text, 'bg-warning text-dark'); }
  showPrimary(text: string)   { this.show(text, 'bg-primary text-light'); }
  showSecondary(text: string) { this.show(text, 'bg-secondary text-dark'); }
  showInfo(text: string)      { this.show(text, 'bg-info text-dark'); }
  showDanger(text: string)    { this.show(text, 'bg-danger text-light'); }
  showLight(text: string)     { this.show(text, 'bg-light text-dark'); }
  showDark(text: string)      { this.show(text, 'bg-dark text-light'); }

  private show(text: string, classname: string, delay = 5000, sticky = false) {
    this.toasts.push({ text, classname, delay, sticky });
  }

  remove(toast: ZikataToast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
